<mat-card class="book-card mat-elevation-z7">
  <div class="thumbnail">
    <img src="{{ book().coverImageUrl }}"
      class="{{ book().type == 'Audible Book' ? 'audible-thumbnail' : 'ebook-thumbnail' }}" />
  </div>
  <div class="book-title">{{book().title}} </div>

  @if (seriesReadingOrder() > -1) {
  <div class="book-series">
    {{ name() }} 
    <br />
    Book
    {{ seriesReadingOrder() }}
  </div>
  }

</mat-card>